module.exports = __webpack_public_path__ + "img/kid-item6.2ad3255c.png";